import { apiHolder, apis } from 'api';
import { InvalidStatusMap } from '../send/validEmailAddress/util';
import { getIn18Text } from 'api';
const trackerApi = apiHolder.api.requireLogicalApi(apis.dataTrackerApiImp);
export const contactBookActionTrackKey = 'pc_marketing_contactBook_action';
const TemplateTypeLabels = {
    2: getIn18Text('GERENMOBAN'),
    4: getIn18Text('QIYEMOBAN'),
    3: getIn18Text('TUIJIANMOBAN'),
    '-100': getIn18Text('CONGYINGXIAORENWUXUANZE'),
};
export const edmDataTracker = {
    track(eventId, attributes) {
        trackerApi.track(eventId, attributes);
    },
    trackPv(pvType, attributes) {
        trackerApi.track(pvType, attributes);
    },
    trackSendBoxFilterClick(filterType) {
        trackerApi.track('pc_markting_edm_sendlist_Filter_click', {
            type: filterType,
        });
    },
    trackSendListOperation(operateType, option) {
        trackerApi.track('pc_markting_edm_sendlist_operation', {
            buttonname: operateType,
        });
    },
    trackEdmDetailOperation(operateType, attributes) {
        trackerApi.track('pc_markting_edm_sendlist_taskdetail_operation', Object.assign({ buttonname: operateType }, attributes));
    },
    trackHistoryAction(from, trigger) {
        const eventId = from === 'detail' ? 'pc_markting_edm_sendlist_taskdetail_history_view' : 'pc_markting_edm_Contacttracking_history_view';
        trackerApi.track(eventId, {
            buttonname: trigger,
        });
    },
    trackDraftListOperation(operateType) {
        trackerApi.track('pc_markting_edm_drafts_operation', {
            buttonname: operateType,
        });
    },
    trackContactFilterClick(filterType, num) {
        trackerApi.track('pc_markting_edm_Contacttracking_Filter_click', {
            type: filterType,
            number: num,
        });
    },
    trackSaveDraft(type, stage) {
        trackerApi.track('pc_markting_edm_sendprocess_save', {
            buttonname: type,
            stage: stage + 1,
        });
    },
    trackNextStep(currentStep) {
        const events = ['pc_markting_edm_sendprocess_setting_nextbutton', 'pc_markting_edm_sendprocess_edit_nextbutton'];
        if (events[currentStep]) {
            trackerApi.track(events[currentStep]);
        }
    },
    trackDraftEditAdd(type) {
        trackerApi.track('pc_markting_edm_sendprocess_edit_add', {
            buttonname: type,
        });
    },
    trackAddReciver(type, attributes) {
        trackerApi.track('pc_markting_edm_sendprocess_contact_add', Object.assign({ type }, attributes));
        trackerApi.track('pc_markting_edm_filter_select', {
            action: 'add',
        });
    },
    trackSendResult(type, attributes) {
        trackerApi.track('pc_markting_edm_sendprocess_contact_send', Object.assign({ type }, attributes));
    },
    trackResendEdm(tab, button) {
        trackerApi.track('pc_markting_edm_sendtask_contact_sendagain', {
            tab,
            button,
        });
    },
    trackWriteSettingTime(time, version) {
        trackerApi.track('pc_markting_edm_sendtask_contact_sendagain_time', {
            time,
            version,
        });
    },
    trackEdmSendType(sendType) {
        trackerApi.track('pc_markting_edm_send_type', {
            send_type: sendType,
        });
    },
    trackEdmSendInvalidContact(contacts) {
        let invalidRecvs = [];
        contacts.forEach(i => {
            let code = parseInt(i.verifyStatus) + 100;
            if (code === InvalidStatusMap[103].id || code === InvalidStatusMap[100].id) {
                invalidRecvs.push(i);
            }
        });
        trackerApi.track('pc_markting_edm_filter_changeContact', {
            contact: invalidRecvs.length,
        });
    },
    trackValidSearch(id, params) {
        if (params && params.searchParam) {
            const { searchItems = [] } = params.searchParam;
            if (searchItems.length === 0) {
                return;
            }
            const [item = {}] = searchItems;
            const { field, searchKeys = [] } = item;
            if (searchKeys.length === 0) {
                return;
            }
            let action = '';
            switch (field) {
                case 'contactAddressInfo':
                    action = 'mail';
                    break;
                case 'companyName':
                    action = 'company';
                    break;
                case 'continent':
                case 'country':
                    action = 'country_region';
                    break;
                case 'contactName':
                    action = 'name';
                    break;
                default:
                    break;
            }
            if (action.length > 0) {
                trackerApi.track(id, {
                    action,
                });
            }
        }
    },
    trackEdmVerifyFail() {
        trackerApi.track('pc_markting_edm_verifyFail');
    },
    trackEdmVerifyFailV2Error(reason, timeout, contactSize) {
        trackerApi.track('pc_markting_edm_verifyFail_v2_error', {
            reason: reason,
            timeout: timeout,
            contactSize: contactSize,
        });
    },
    trackEdmVerifyFailCheckError(reason, timeout, contactSize, repeatCount) {
        trackerApi.track('pc_markting_edm_verifyFail_check_error', {
            reason: reason,
            timeout: timeout,
            contactSize: contactSize,
            repeatCount: repeatCount,
        });
    },
    trackEdmAiContentError(params) {
        trackerApi.track('pc_markting_edm_ai_content_error', params);
    },
    trackEdmValidemailTime(params) {
        trackerApi.track('pc_markting_edm_validemail_time', params);
    },
    trackEdmWritePageLoadTime(params) {
        trackerApi.track('pc_markting_edm_writePage_load_time', params);
    },
    trackCustomerCard() {
        trackerApi.track('pc_markting_edm_customer_label');
    },
    trackCustomerCardClick() {
        trackerApi.track('pc_markting_edm_customer_label_click');
    },
    trackCustomerCardOp() {
        trackerApi.track('pc_markting_edm_customer_card_click');
    },
    trackMarktingEdmFilterCreate() {
        trackerApi.track('pc_markting_edm_filterCreate');
    },
    trackMarktingEdmFilterMinimize() {
        trackerApi.track('pc_markting_edm_filterMinimize');
    },
    trackMarktingEdmFilterDirect() {
        trackerApi.track('pc_markting_edm_filterDirect');
    },
    trackMarktingEdmFilterType(filter_type) {
        trackerApi.track('pc_markting_edm_filter_type', {
            filter_type: filter_type,
        });
    },
    trackMarktingEdmFilterEnding(type) {
        trackerApi.track('pc_markting_edm_filterEnding', {
            type: type,
        });
    },
    trackMarktingEdmFilterTime(time) {
        trackerApi.track('pc_markting_edm_filterTime', {
            time: time,
        });
    },
    trackMarktingEdmFilterSource(source) {
        trackerApi.track('pc_markting_edm_emailSource', {
            source: source,
        });
    },
    trackMarktingEdmResetClick() {
        trackerApi.track('pc_markting_edm_reset_click');
    },
    trackMarktingEdmTaskCreate(source) {
        trackerApi.track('pc_markting_edm_taskCreate', {
            source: source,
        });
    },
    trackMarktingEdmTaskSuccess(type, source) {
        trackerApi.track('pc_markting_edm_taskSucess', {
            type: type,
            source: source,
        });
    },
    trackMarktingEdmFilterSucess() {
        trackerApi.track('pc_markting_edm_filterSucess');
    },
    trackFiltrationShortageView() {
        trackerApi.track('pc_markting_edm_filtration_shortage_view');
    },
    trackFiltrationShortageClick(action) {
        trackerApi.track('pc_markting_edm_filtration_shortage_click', {
            action: action,
        });
    },
    trackEdmContactsCreate() {
        trackerApi.track('pc_markting_edm_contacts_create');
    },
    trackEdmContactsChange() {
        trackerApi.track('pc_markting_edm_contacts_change');
    },
    trackMarketingTemplate(params) {
        trackerApi.track('pc_markting_edm_task_save_as_template', params);
    },
    trackTemplateBtn() {
        trackerApi.track('pc_markting_edm_writeMailPage_template_click');
    },
    trackTemplateBtnType(type) {
        trackerApi.track('pc_markting_edm_writeMailPage_template_item_click', {
            click_content: TemplateTypeLabels[type],
        });
    },
    trackAiWriteBtnClick() {
        trackerApi.track('waimao_mail_click_aiWritingemail');
    },
    trackAiOptimizeBtnClick() {
        trackerApi.track('waimao_mail_click_aiRephrase');
    },
    socialLinkSubmit(type) {
        trackerApi.track('pc_markting_edm__taskdetail_multi_subjects_click', {
            social_media_type: type,
        });
    },
    generateReportClick(count) {
        trackerApi.track('pc_markting_report_click', {
            task_number: count,
        });
    },
    generateReportResult(result) {
        trackerApi.track('pc_markting_report_result', {
            result,
        });
    },
    generateReportTime(time) {
        trackerApi.track('pc_markting_report_time_request', {
            time,
        });
    },
    generateReportPdfClick() {
        trackerApi.track('pc_markting_report_download_click');
    },
    reportPageViewTime(time) {
        trackerApi.track('pc_markting_report_view_time', {
            time,
        });
    },
    secondSendSwitch(action) {
        trackerApi.track('pc_markting_edm_secondaryMarketing_switch_click', {
            action,
        });
    },
    clickSecondSendInfo() {
        trackerApi.track('pc_markting_edm_secondaryMarketing_read_more_click');
    },
    secondSendFilter(type) {
        trackerApi.track('pc_markting_secondaryMarketing_select', {
            type,
        });
    },
    secondSendStrategy(info) {
        trackerApi.track('pc_markting_edm_secondaryMarketing_cardOperation', info);
    },
    dataViewAction(action) {
        trackerApi.track('pc_marketing_edm_entrust_data', action ? { action } : {});
    },
    taskIntellectTrack(source) {
        trackerApi.track('pc_markting_edm_knowledgeCenter', { source });
    },
    aiGenerateThem() {
        trackerApi.track('waimao_mail_aiSubject_create');
    },
    aiRewriteTheme() {
        trackerApi.track('waimao_mail_aiSubject_rephrase');
    },
    aiHostingOverviewAction(action) {
        trackerApi.track('pc_marketing_edm_host_data', { action });
    },
    successPage(action) {
        trackerApi.track('pc_markting_edm_taskSuccess', action);
    },
    successPageAiHosting(action) {
        trackerApi.track('pc_markting_edm_successHost_create', action);
    },
    successPageWiki(action) {
        trackerApi.track('pc_markting_edm_successKnowledge_show', action);
    },
    successPageWikiItemAction(action) {
        trackerApi.track('pc_markting_edm_successKnowledge_click', action);
    },
    taskDetailClick() {
        trackerApi.track('pc_markting_edm__taskdetail_mailbound_guide_click', { click: '点击' });
    },
    taskDetailTip() {
        trackerApi.track('pc_markting_edm__taskdetail_mailbound_guide_click_successtip', { tip: '提示' });
    },
    aiHostingDataView(action) {
        trackerApi.track('pc_marketing_edm_entrust_data', { action });
    },
    marktingEdmTaskListAlert() {
        trackerApi.track('markting_edm_taskList_alert', {});
    },
    marktingEdmTaskListNewbox(type) {
        trackerApi.track('pc_markting_edm_taskList_newBox', { type });
    },
    marketingEdmVideoClose(eventId, config) {
        trackerApi.track(eventId, config);
    },
    taskDiagnosisPv() {
        trackerApi.track('task_list_diagnosis_and_recommendation_pv', {});
    },
    templatePageOp(type, source) {
        trackerApi.track('pc_markting_edm_contentLibrary_click', {
            type,
            source,
        });
    },
    templatePageEnter() {
        trackerApi.track('pc_markting_edm_contentLibrary_view', {});
    },
    anxinfaTips() {
        trackerApi.track('pc_markting_edm_excessive_sending', {});
    },
    sendTask(version, type) {
        trackerApi.track('pc_markting_edm_sendprocess_send', {
            version,
            type,
        });
    },
    trySendTask(version, type) {
        trackerApi.track('pc_markting_edm_sendprocess_test', {
            version,
            type,
        });
    },
    cronSendTask(version, type) {
        trackerApi.track('pc_markting_edm_sendprocess_scheduled_send', {
            version,
            type,
        });
    },
    taskListDiagnosisClick(type) {
        trackerApi.track('task_list_diagnosis_and_recommendation_click', {
            type,
        });
    },
    upfourCustomersdagnoseClick(type) {
        trackerApi.track('upfour_customersdagnose_click', {
            type,
        });
    },
    belowfourCustomersdagnoseClick(type) {
        trackerApi.track('belowfour_customersdagnose_click', {
            type,
        });
    },
    taskDiagnosisCollapseOpen(type) {
        trackerApi.track('task_diagnosis_collapse_open', { type });
    },
    taskDiagnosisSuccessCount(params) {
        trackerApi.track('success_detection_times_sending_records', params);
    },
    replayMailCheck(type) {
        trackerApi.track('pc_markting_edm_replyMail_check', {
            show: 1,
            type,
        });
    },
    recommendShow(from) {
        trackerApi.track('pc_markting_edm_recommend_show', {
            show: 1,
            from,
        });
    },
    recommendContactShow() {
        trackerApi.track('pc_markting_edm_recommend_contact_show');
    },
    recommendContactClick(type) {
        trackerApi.track('pc_markting_edm_recommend_contact_click', { type });
    },
    recommendContactViewAll() {
        trackerApi.track('pc_markting_edm_recommend_contact_viewAll_show');
    },
    recommendContactViewAllClick(type) {
        trackerApi.track('pc_markting_edm_recommend_contact_viewAll_click', { type });
    },
    recommendEdmTypeShow() {
        trackerApi.track('pc_markting_edm_recommend_edmType_show');
    },
    recommendEdmTypeClick(type) {
        trackerApi.track('pc_markting_edm_recommend_edmType_click', { type });
    },
    recommendEdmTypeViewAll() {
        trackerApi.track('pc_markting_edm_recommend_edmType_viewAll_show');
    },
    recommendEdmTypeViewAllClick(type) {
        trackerApi.track('pc_markting_edm_recommend_edmType_viewAll_click', { type });
    },
    recommendCreateSingleShow() {
        trackerApi.track('pc_markting_edm_recommend_createSingle_show');
    },
    recommendCreateSingleClick(type) {
        trackerApi.track('pc_markting_edm_recommend_createSingle_click', { type });
    },
    recommendCreateSingleViewAll() {
        trackerApi.track('pc_markting_edm_recommend_createSingle_viewAll_show');
    },
    recommendCreateSingleViewAllClick(type) {
        trackerApi.track('pc_markting_edm_recommend_createSingle_viewAll_click', { type });
    },
    recommendCreateHostShow() {
        trackerApi.track('pc_markting_edm_recommend_createHost_show');
    },
    recommendCreateHostClick(type) {
        trackerApi.track('pc_markting_edm_recommend_createHost_click', { type });
    },
    recommendCreateHostViewAll() {
        trackerApi.track('pc_markting_edm_recommend_createHost_viewAll_show');
    },
    recommendCreateHostViewAllClick(type) {
        trackerApi.track('pc_markting_edm_recommend_createHost_viewAll_click', { type });
    },
    recommendSuccessShow() {
        trackerApi.track('pc_markting_edm_recommend_success_show');
    },
    recommendSuccessClick(type) {
        trackerApi.track('pc_markting_edm_recommend_success_click', { type });
    },
    recommendSuccessViewAll() {
        trackerApi.track('pc_markting_edm_recommend_success_viewAll_show');
    },
    recommendSuccessViewAllClick(type) {
        trackerApi.track('pc_markting_edm_recommend_success_viewAll_click', { type });
    },
    autoEdmContacts() {
        trackerApi.track('pc_markting_autoEdm_edit_contactView');
    },
    autoEdmContactsAction(type) {
        trackerApi.track('pc_markting_autoEdm_edit_contactAction', { type });
    },
    autoSearchCreate(param) {
        trackerApi.track('pc_markting_autoEdm_autoSearch_create', param);
    },
    successPageView() {
        trackerApi.track('pc_markting_autoEdm_create_successView', {});
    },
    successPageAction(type) {
        trackerApi.track('pc_markting_autoEdm_create_successAction', { type });
    },
    recCompanyCount(number) {
        trackerApi.track('pc_markting_autoEdm_companyCount', { number });
    },
    errorReasonClick() {
        trackerApi.track('pc_markting_autoEdm_planCheck_action', {});
    },
};
export var EDMPvType;
(function (EDMPvType) {
    EDMPvType["EdmModule"] = "pc_markting_edm_view";
    EDMPvType["SendList"] = "pc_markting_edm_sendlist_view";
    EDMPvType["Draft"] = "pc_markting_edm_drafts_view";
    EDMPvType["ContactTracking"] = "pc_markting_edm_Contacttracking_view";
    EDMPvType["EdmDetail"] = "pc_markting_edm_sendlist_Filter_click";
    EDMPvType["SendProcess"] = "pc_markting_edm_sendprocess_stage_view";
})(EDMPvType || (EDMPvType = {}));
export var EdmSendListOperateType;
(function (EdmSendListOperateType) {
    EdmSendListOperateType["Delete"] = "delete";
    EdmSendListOperateType["Copy"] = "copy";
    EdmSendListOperateType["Revert"] = "backout";
    EdmSendListOperateType["ViewThumbnail"] = "viewthumbnail";
    EdmSendListOperateType["Detail"] = "detail";
    EdmSendListOperateType["NewObject"] = "newobject";
})(EdmSendListOperateType || (EdmSendListOperateType = {}));
export var EdmSendListFilterType;
(function (EdmSendListFilterType) {
    EdmSendListFilterType["SendTime"] = "SendTime";
    EdmSendListFilterType["UpdateTime"] = "UpdateTime";
    EdmSendListFilterType["Search"] = "Search";
    EdmSendListFilterType["State"] = "state";
    EdmSendListFilterType["Manager"] = "manager";
    EdmSendListFilterType["ContactEmail"] = "ContactEmail";
    EdmSendListFilterType["DelState"] = "DelState";
})(EdmSendListFilterType || (EdmSendListFilterType = {}));
export var EdmDetailOperateType;
(function (EdmDetailOperateType) {
    EdmDetailOperateType["Reuse"] = "reuse";
    EdmDetailOperateType["View"] = "view";
    EdmDetailOperateType["Tab"] = "tab";
    EdmDetailOperateType["CreatAutoJob"] = "creatautojob";
})(EdmDetailOperateType || (EdmDetailOperateType = {}));
export var HistoryActionTrigger;
(function (HistoryActionTrigger) {
    HistoryActionTrigger["ReadCount"] = "read";
    HistoryActionTrigger["Unsubscribe"] = "unsubscribe";
    HistoryActionTrigger["Reply"] = "reply";
    HistoryActionTrigger["Arrive"] = "arrive";
    HistoryActionTrigger["Send"] = "send";
})(HistoryActionTrigger || (HistoryActionTrigger = {}));
export var EdmDraftListOperateType;
(function (EdmDraftListOperateType) {
    EdmDraftListOperateType["NewObject"] = "newobject";
    EdmDraftListOperateType["SendNow"] = "send";
    EdmDraftListOperateType["Edit"] = "edit";
    EdmDraftListOperateType["Delete"] = "delete";
})(EdmDraftListOperateType || (EdmDraftListOperateType = {}));
export var ContactTrackingFilterType;
(function (ContactTrackingFilterType) {
    ContactTrackingFilterType["Sent"] = "sent";
    ContactTrackingFilterType["State"] = "state";
    ContactTrackingFilterType["OpenNum"] = "opennumber";
    ContactTrackingFilterType["SendNum"] = "sendnumber";
    ContactTrackingFilterType["ArriveNum"] = "arrivenumber";
})(ContactTrackingFilterType || (ContactTrackingFilterType = {}));
export var DraftSaveType;
(function (DraftSaveType) {
    DraftSaveType["Save"] = "save";
    DraftSaveType["Back"] = "back autosave";
    DraftSaveType["Next"] = "next autosave";
})(DraftSaveType || (DraftSaveType = {}));
export var DraftEditAdd;
(function (DraftEditAdd) {
    DraftEditAdd["Attachment"] = "accessory";
    DraftEditAdd["Image"] = "pic";
    DraftEditAdd["Unsubscribe"] = "unsubscribe";
    DraftEditAdd["ContactName"] = "contact";
})(DraftEditAdd || (DraftEditAdd = {}));
export var AddReceiverType;
(function (AddReceiverType) {
    AddReceiverType["Manual"] = "Manual";
    AddReceiverType["Import"] = "import";
    AddReceiverType["Select"] = "select";
    AddReceiverType["SelectFromPersonalContact"] = "selectPersonalContact";
})(AddReceiverType || (AddReceiverType = {}));
